// extracted by mini-css-extract-plugin
module.exports = {"chatWindow":"ChatList_chatWindow__3OzuM","chatDay":"ChatList_chatDay__5PYy_","chatDayTitle":"ChatList_chatDayTitle__3Iwq5"};